"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Dialog: function() {
        return _Dialog.Dialog;
    },
    renderDialog_unstable: function() {
        return _Dialog.renderDialog_unstable;
    },
    useDialog_unstable: function() {
        return _Dialog.useDialog_unstable;
    },
    DialogTrigger: function() {
        return _DialogTrigger.DialogTrigger;
    },
    useDialogTrigger_unstable: function() {
        return _DialogTrigger.useDialogTrigger_unstable;
    },
    renderDialogTrigger_unstable: function() {
        return _DialogTrigger.renderDialogTrigger_unstable;
    },
    DialogActions: function() {
        return _DialogActions.DialogActions;
    },
    dialogActionsClassNames: function() {
        return _DialogActions.dialogActionsClassNames;
    },
    useDialogActions_unstable: function() {
        return _DialogActions.useDialogActions_unstable;
    },
    useDialogActionsStyles_unstable: function() {
        return _DialogActions.useDialogActionsStyles_unstable;
    },
    renderDialogActions_unstable: function() {
        return _DialogActions.renderDialogActions_unstable;
    },
    DialogBody: function() {
        return _DialogBody.DialogBody;
    },
    dialogBodyClassNames: function() {
        return _DialogBody.dialogBodyClassNames;
    },
    useDialogBody_unstable: function() {
        return _DialogBody.useDialogBody_unstable;
    },
    useDialogBodyStyles_unstable: function() {
        return _DialogBody.useDialogBodyStyles_unstable;
    },
    renderDialogBody_unstable: function() {
        return _DialogBody.renderDialogBody_unstable;
    },
    DialogTitle: function() {
        return _DialogTitle.DialogTitle;
    },
    dialogTitleClassNames: function() {
        return _DialogTitle.dialogTitleClassNames;
    },
    useDialogTitle_unstable: function() {
        return _DialogTitle.useDialogTitle_unstable;
    },
    useDialogTitleStyles_unstable: function() {
        return _DialogTitle.useDialogTitleStyles_unstable;
    },
    renderDialogTitle_unstable: function() {
        return _DialogTitle.renderDialogTitle_unstable;
    },
    DialogSurface: function() {
        return _DialogSurface.DialogSurface;
    },
    dialogSurfaceClassNames: function() {
        return _DialogSurface.dialogSurfaceClassNames;
    },
    useDialogSurface_unstable: function() {
        return _DialogSurface.useDialogSurface_unstable;
    },
    useDialogSurfaceStyles_unstable: function() {
        return _DialogSurface.useDialogSurfaceStyles_unstable;
    },
    useDialogSurfaceContextValues_unstable: function() {
        return _DialogSurface.useDialogSurfaceContextValues_unstable;
    },
    renderDialogSurface_unstable: function() {
        return _DialogSurface.renderDialogSurface_unstable;
    },
    DialogContent: function() {
        return _DialogContent.DialogContent;
    },
    dialogContentClassNames: function() {
        return _DialogContent.dialogContentClassNames;
    },
    useDialogContent_unstable: function() {
        return _DialogContent.useDialogContent_unstable;
    },
    useDialogContentStyles_unstable: function() {
        return _DialogContent.useDialogContentStyles_unstable;
    },
    renderDialogContent_unstable: function() {
        return _DialogContent.renderDialogContent_unstable;
    },
    useDialogContext_unstable: function() {
        return _index.useDialogContext_unstable;
    },
    useDialogSurfaceContext_unstable: function() {
        return _index.useDialogSurfaceContext_unstable;
    },
    DialogProvider: function() {
        return _index.DialogProvider;
    },
    DialogSurfaceProvider: function() {
        return _index.DialogSurfaceProvider;
    }
});
const _Dialog = require("./Dialog");
const _DialogTrigger = require("./DialogTrigger");
const _DialogActions = require("./DialogActions");
const _DialogBody = require("./DialogBody");
const _DialogTitle = require("./DialogTitle");
const _DialogSurface = require("./DialogSurface");
const _DialogContent = require("./DialogContent");
const _index = require("./contexts/index");
